import React, { Component } from 'react';
import {connect} from 'react-redux';
import './style.scss';
import withAuth from '../../../components/Services/WithAuth';
import {
    Button, Col,
    Row, Card, CardBody, Form,
    FormGroup, Label
} from 'reactstrap';
import MyAutosuggest from '../../../components/ReusableComponents/AutoSuggest/index';
class SearchScorecardComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRiskType: 'qualitative',
            selectedOption: null,
            searchId: ''
        };
    }


    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };
    handleView(event) {
        event.preventDefault();
        this.props.history.push(`/scorecard/view/${this.state.selectedOption.id}`)
    }
    handleCreateScorecard(event) {
        event.preventDefault();
        this.props.history.push('/scorecard/create');
    }
    searchCallback = (value) => {
        if (value.id) {
            this.setState({
                selectedOption: value
            });
        } else {
            this.setState({ selectedOption: [] });
        }
    }
    render() {
        const { value } = this.state;
        let inputProps = {
            placeholder: "Start typing to search scorecards...",
            value,
            onChange: this.onChange,
            disabled: false,
            className: "form-control"
        }
        return (
            <Col>
                <Row>
                    <Col>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">
                                Search Scorecard
                            </h4>
                            <Button color="primary" disabled={!this.state.selectedRiskType} title="Create Scorecard" onClick={(event) => this.handleCreateScorecard(event)}>Create Scorecard</Button>
                        </div>
                        <Card>
                            <CardBody>
                                <Form className="w-70">
                                    <FormGroup>
                                        <Label for="riskTypeSelect">Search</Label>
                                        <Row>
                                            <Col xs="20">
                                                <MyAutosuggest
                                                    id="scorecardSearch"
                                                    placeholder="Search Scorecard"
                                                    onChange={this.handleFinancialChange}
                                                    financialData={this.props.financialSearch}
                                                    searchCallback={this.searchCallback}
                                                    inputProps={inputProps}
                                                />
                                            </Col>
                                            <Col xs="4" className="pl-0">
                                                <Button className="pl-0" color="link" onClick={(event) => this.handleView(event)} disabled={!this.state.selectedOption}>View Details</Button>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Col>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
});

const mapDispatchToProps = (dispatch, ownProps) => ({
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(SearchScorecardComponent));
